import { CUSTOM_VALIDATION_ERRORS } from "./core/utilities/validators/custom-validation-errors";
import { BrowserModule, Title } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule, LOCALE_ID, APP_INITIALIZER } from "@angular/core";
import { registerLocaleData } from "@angular/common";
import ptBr from "@angular/common/locales/pt";
registerLocaleData(ptBr);
import { CommonModule } from "@angular/common";
import { CoreModule } from "./core/core.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ToastrModule } from "ngx-toastr";
import {
  NgBootstrapFormValidationModule,
  CUSTOM_ERROR_MESSAGES,
} from "ng-bootstrap-form-validation";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { StoreModule } from "@ngrx/store";
import {
  NgxUiLoaderModule,
  NgxUiLoaderHttpModule,
  NgxUiLoaderConfig,
  NgxUiLoaderRouterModule,
} from "ngx-ui-loader";

import { StatusConexaoModule } from "src/app/refact/shared/components/teste-conexao/status-conexao/status-conexao.module";
import { statusConexaoReducer } from "src/app/refact/shared/components/teste-conexao/status-conexao/store/status-conexao.reducer";
import { qualidadeConexaoReducer } from "src/app/refact/shared/components/teste-conexao/qualidade-conexao/store/qualidade-conexao.reducer";
import { environment as env } from "src/environments/environment";
import { TitleService } from "./core/services/title.service";
import { SingleDataPickerModule } from "./refact/shared/components/single-data-picker/single-data-picker.module";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { LoadingInterceptor } from "./refact/shared/components/loading/interceptor/loading.interceptor";
import { LoadingService } from "./refact/shared/components/loading/services/loading.service";
import { LoadingModule } from "./refact/shared/components/loading/loading.module";
import { HttpClientModule } from '@angular/common/http';
import { AppConfigService } from './core/services/app-config.service';
import { HttpClientTestingModule } from "@angular/common/http/testing";
import { AcessoNegadoContentComponent } from './refact/shared/services/acesso-negado/acesso-negado-content.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgSelectConfig } from '@ng-select/ng-select';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: "#00609c",
  bgsOpacity: 0.5,
  bgsPosition: "center-center",
  bgsSize: 60,
  bgsType: "ball-scale-multiple",
  blur: 0,
  delay: 0,
  fastFadeOut: true,
  fgsColor: "#00609c",
  fgsPosition: "center-center",
  fgsType: "ball-spin-clockwise",
  gap: 24,
  logoPosition: "center-center",
  logoSize: 120,
  logoUrl: "",
  masterLoaderId: "master",
  overlayBorderRadius: "0",
  overlayColor: "rgba(40,40,40,0.3)",
  pbColor: "#00609c",
  pbDirection: "ltr",
  pbThickness: 3,
  hasProgressBar: true,
  text: "",
  textColor: "#FFFFFF",
  textPosition: "center-center",
  maxTime: -1,
  minTime: 300,
};

export function resourceProviderFactory(provider: TitleService) {
  return () => provider.setFavicon();
}

export function appConfigInitializer(configService: AppConfigService) {
  return () => configService.load();
}

@NgModule({
  declarations: [AppComponent, AcessoNegadoContentComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    CoreModule,
    NgbModule,
    LoadingModule,
    HttpClientModule,
    /* NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderHttpModule.forRoot({
      showForeground: true,
      excludeRegexp: [
        "/api/v1/ClienteMalote/info",
        "/api/v1/Referencia",
        "/api/v1/notificacao/novas",
        "/api/v1/notificacao/visualizar-todas",
        "/api/v1/ecommerce/integracoes",
        "api/v1/VendaInUp/ReprocessarVendasBluve"
      ],
    }), */
    NgBootstrapFormValidationModule.forRoot(),
    ToastrModule.forRoot(),
    StoreModule.forRoot({
      statusConexao: statusConexaoReducer,
      qualidadeConexao: qualidadeConexaoReducer,
    }),
    StatusConexaoModule,
    AppRoutingModule,
    SingleDataPickerModule,
    ModalModule.forRoot(),
    //TopCardModule,
  ],
  providers: [
    Title,
    {
      provide: LOCALE_ID,
      useValue: "pt-BR",
    },
    {
      provide: APP_INITIALIZER,
      useFactory: resourceProviderFactory,
      deps: [TitleService],
      multi: true,
    },
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appConfigInitializer,
      deps: [AppConfigService],
      multi: true,
    },    
    {
      provide: APP_INITIALIZER,
      useFactory: (config: NgSelectConfig) => () => {
        config.notFoundText = 'Nenhum item encontrado';
        config.typeToSearchText = 'Digite para pesquisar';
        config.loadingText = 'Carregando...';
        config.clearAllText = 'Limpar todos';
      },
      deps: [NgSelectConfig],
      multi: true,
    },
    {
      provide: CUSTOM_ERROR_MESSAGES,
      useValue: CUSTOM_VALIDATION_ERRORS,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true
    },
    LoadingService
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
